import { render, staticRenderFns } from "./ConnectComponent.vue?vue&type=template&id=d227209c&scoped=true&"
import script from "./ConnectComponent.vue?vue&type=script&lang=js&"
export * from "./ConnectComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d227209c",
  null
  
)

export default component.exports